import Row from '@components/row'
import Wrapper from '@components/wrapper'
import React, { useEffect, useState } from 'react'
import { Stylesubtitle, StyleTitle } from '../style'
import { Form, Formik } from 'formik'
import Fields from '@components/fields'
import Button from '@components/button'
import styled from '@emotion/styled'
import useIsMobile from '@hooks/useIsMobile'
import generalSettings from '@apis/generalSettings'
import { toast } from 'react-toastify'

const ResponsiveRow = styled(Row)`
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }
`

const LeftColumn = styled.div`
  flex: 2;
  min-width: 300px;

  @media (max-width: 768px) {
    flex: 1;
    width: 100%;
    margin-bottom: 10px;
  }
`

const RightColumn = styled.div`
  flex: 1;
  min-width: 250px;
  transform: translateY(68px);

  @media (max-width: 768px) {
    flex: 1;

    transform: none;
    margin-top: 10px;
  }
`

const FormContainer = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  @media (max-width: 768px) {
    justify-content: center;
    margin-top: 15px;
  }
`

const CancellationSetting = () => {
  const isMobile = useIsMobile()
  const [existing, setExisting] = useState<any | null>(null)

  // Fetch existing settings
  const fetchSettings = async () => {
    try {
      const data = await generalSettings.getByKey({
        id: 'cancellation-settings',
        state: 'cancellationSetting',
      })
      if (data) setExisting(data)
    } catch (err) {
      console.error('Failed to fetch cancellation settings', err)
    }
  }

  useEffect(() => {
    fetchSettings()
  }, [])

  const handleSubmit = async (values: {
    cancellationPercent: string
    hoursAllowed: string
  }) => {
    if (!values.cancellationPercent || !values.hoursAllowed) {
      toast.error('Cannot leave field empty')
    }
    const payload: any = {
      key: 'cancellation-settings',
      value: JSON.stringify({
        cancellationPercent: values.cancellationPercent,
        hoursAllowed: values.hoursAllowed,
      }),
    }
    if (!existing.id) {
      payload.group = 'platform-settings'
    }
    try {
      if (existing?.id) {
        await generalSettings.update({
          id: existing.id,
          state: 'cancellationSetting',
          data: payload,
        })
        toast.success('Cancellation settings updated')
      } else {
        await generalSettings.create({
          state: 'cancellationSetting',
          data: JSON.stringify(payload),
        })
      }
    } catch (err) {
      console.error('Failed to save cancellation settings', err)
    }
  }

  return (
    <Wrapper>
      <Formik
        enableReinitialize
        initialValues={{
          cancellationPercent: existing?.value
            ? JSON.parse(existing.value).cancellationPercent
            : '',
          hoursAllowed: existing?.value
            ? JSON.parse(existing.value).hoursAllowed
            : '',
        }}
        onSubmit={handleSubmit}
      >
        <FormContainer>
          <ResponsiveRow>
            <LeftColumn>
              <StyleTitle>Cancellation Settings</StyleTitle>
              <Stylesubtitle>
                Admin can manage cancellation rates and timings
              </Stylesubtitle>
              <br />
              <Fields.Input
                name="cancellationPercent"
                label="Cancellation Percentage"
                placeholder="Enter points"
                disabled={true}
              />
            </LeftColumn>

            <RightColumn>
              <Fields.Input
                name="hoursAllowed"
                label="Hours Allowed to cancel"
                placeholder="Hours allowed to cancel ticket and get refund"
              />
            </RightColumn>
          </ResponsiveRow>

          <ButtonContainer>
            <Button type="submit" title="Save Settings" justify="end" />
          </ButtonContainer>
        </FormContainer>
      </Formik>
    </Wrapper>
  )
}

export default CancellationSetting
